import ApiService from '../api.services';

const PriceDeadLineService = {
    deadLinePrice: async function( service ){
        try {
            const response = await ApiService.post('/api/price.deadline/deadlinePrice', service);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    listStates: async function (serviceId) {
        try {
            const response = await ApiService.get(`/api/price.deadline/state/all?serviceId=${encodeURIComponent(serviceId)}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    saveStates: async function (serviceId, deadlines) {
        try {
            const response = await ApiService.post('/api/price.deadline/state', { serviceId, deadlines });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default PriceDeadLineService;

export { PriceDeadLineService };